export default __webpack_public_path__ + "static/media/img.5c0353cd.png";